(() => {
  const init = () => {
    const card = document.querySelector('[data-welcome-card]');
    if (!card || card.dataset.initialized) return;
    card.dataset.initialized = 'true';
    const config = JSON.parse(card.querySelector('[data-welcome-config]').textContent);
    const status = card.querySelector('[data-welcome-status]');
    const form = card.closest('[data-product-section]')?.querySelector('[data-product-form]');
    const register = card.querySelector('[data-welcome-register]');
    register?.addEventListener('click', event => {
      if (card.dataset.preview === 'true') { event.preventDefault(); status.textContent = config.text.preview; return; }
      const target = new URL(location.href);
      const variant = form?.elements.id?.value;
      if (variant) target.searchParams.set('variant', variant);
      target.hash = 'WelcomeOffer';
      const returnTo = target.pathname + target.search + target.hash;
      register.href = config.root + 'pages/sign-in?return_to=' + encodeURIComponent(returnTo);
      if (window.MinglangMember) {
        event.preventDefault();
        window.MinglangMember.handoff({action:'navigate', target:returnTo});
      }
    });
    if (!['eligible','check'].includes(card.dataset.state)) return;
    card.querySelector('[data-welcome-claim]')?.addEventListener('click', async () => {
      if (card.dataset.preview === 'true') { status.textContent = config.text.preview; return; }
      const codeField = card.querySelector('[data-welcome-code]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(config.code);
        status.textContent = config.text.copied;
      } catch {
        codeField?.focus(); codeField?.select();
        status.textContent = config.text.fallback;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
